import React from 'react';
import { Link, Text, FlexCrate } from '@perch-labs/shrike';
import { Card, Container } from 'styles';
import { vnmExplainerGuide } from 'domain/vnm';
import { copyFor } from 'config';
import Graphic from '/images/solar/solar-home.svg';
import SVG from 'react-inlinesvg';

const getCopy = copyFor('dashboard.waitlistDashboard');

interface Props {
  state: string;
}

export const WaitlistInfo = (props: Props) => {
  const { state } = props;

  return (
    <Card mobileVariant="flat" margin="0">
      <Card.Content>
        <Text
          textStyle="heading700"
          tag="h1"
          margin={{ bottom: '16px', top: '40px' }}
        >
          {getCopy('title', { state })}
        </Text>
        <Text margin={{ bottom: '24px' }}>
          {getCopy('subTitle', { state })}{' '}
          <Link type="inline" href={vnmExplainerGuide}>
            {getCopy('link')}
          </Link>
          .
        </Text>
        <FlexCrate
          padding={{ vertical: '16px', horizontal: '16px' }}
          margin="0 auto"
          height="auto"
          backgroundColor="success"
          borderRadius="8px"
          gap="16px"
        >
          <Container flex justifyContent="center">
            <SVG src={Graphic} />
          </Container>
          <Container>
            <Text textStyle="paragraph600">{getCopy('header')}</Text>
            <Text textStyle="paragraph400" color="secondary">
              {getCopy('subHeader')}
            </Text>
          </Container>
        </FlexCrate>
      </Card.Content>
    </Card>
  );
};
